module.exports = __webpack_public_path__ + "img/talentidentified-hire-ratio.89539578.png";